import { ContactDetailType } from './contactDetailType';

export class Contact {
  Id?: string;
  Value? : string;
  ContactType: ContactDetailType = ContactDetailType.PhoneContact;
}